/**
 * Lista de opções ENVIADA pelo Whiz (bot ou API): o servidor grava
 * `conteudo = { titulo, lista }`, onde `lista` é a string JSON de
 * `{ titulo, rotuloBotao, opcoes: [{ id, titulo, descricao? }] }` — forma
 * diferente da lista RECEBIDA pelo baileys (`secoes`/`textoBotao`).
 *
 * O `conteudo` é MAP<TEXT,TEXT> no Cassandra, então `lista` chega como string;
 * aceita objeto também (evento do websocket antes de passar pelo banco).
 */
export type ListaEnviada = {
    titulo?: string;
    rotuloBotao?: string;
    opcoes?: { id: string | number; titulo: string; descricao?: string }[];
};

export function lerListaEnviada(conteudo: unknown): ListaEnviada | undefined {
    const bruto = (conteudo as { lista?: unknown } | null | undefined)?.lista;
    if (!bruto) return undefined;
    let lista: unknown = bruto;
    if (typeof bruto === 'string') {
        try { lista = JSON.parse(bruto); } catch { return undefined; }
    }
    if (!lista || typeof lista !== 'object' || !Array.isArray((lista as ListaEnviada).opcoes)) return undefined;
    return lista as ListaEnviada;
}

/**
 * Linha de lista enviada que o servidor regravou como GENERICA. O webhook de
 * status da Meta reescrevia o tipo (corrigido no servidor), e GENERICA é
 * filtrada da conversa — a lista sumia. Resolver pelo conteúdo recupera o
 * histórico já gravado sem backfill.
 */
export function ehListaEnviadaGravadaComoGenerica(conteudo: unknown): boolean {
    return !!lerListaEnviada(conteudo);
}
